<template>
  <div v-if="pax || withoutPax">
    <template v-if="withChip">
      <q-chip
        v-if="!withoutPax"
        key="with-image"
        outline
        color="grey-4"
        class="q-ml-none"
      >
        <span class="text-black">
          {{ $t('transfer.adults') }} × <b>{{ pax - children }}</b>
        </span>
      </q-chip>
      <template v-if="children">
        <template v-for="(childSeat, key) in childSeats">
          <q-chip
            v-if="childSeats[key]"
            :key="key"
            outline
            color="grey-4"
            class="q-ml-none"
          >
            <q-icon
              size="xs"
              :name="`img:common/icons/child_seats_${key}.svg`"
            />
            <span class="text-black">
              × <b>{{ childSeat }}</b>
            </span>
            <Tooltip>
              {{ $t(`transfer.child_seats_${key}.title`) }} × {{ childSeat }}
            </Tooltip>
          </q-chip>
        </template>
      </template>
    </template>
    <template v-else>
      <span
        v-if="children"
        class="text-no-wrap"
      >
        <q-icon
          name="img:common/icons/child-seat.svg"
          size="sm"
        />
        × <b>{{ children }}</b>
      </span>
      <span class="text-no-wrap">
        <q-icon
          name="img:common/icons/pax.svg"
          size="sm"
        />
        × <b>{{ pax - children }}</b>
      </span>
    </template>
  </div>
  <div v-else>—</div>
</template>

<script setup>
import { computed } from 'vue';

import Tooltip from './Tooltip';

const props = defineProps({
  pax: {
    type: Number,
    default: null,
  },
  childSeatsBooster: {
    type: Number,
    required: true,
  },
  childSeatsConvertible: {
    type: Number,
    required: true,
  },
  childSeatsInfant: {
    type: Number,
    required: true,
  },
  withChip: {
    type: Boolean,
    default: false,
  },
  withoutPax: {
    type: Boolean,
    default: false,
  },
});

const childSeats = computed(() => ({
  infant: props.childSeatsInfant,
  convertible: props.childSeatsConvertible,
  booster: props.childSeatsBooster,
}));

const children = computed(() => props.childSeatsBooster + props.childSeatsConvertible + props.childSeatsInfant);
</script>
